import React from 'react'
import { graphql } from 'gatsby'
import { JobType } from './mapper'

type FirmJobTypesProps = {
  jobTypes: JobType[] | null
}

const FirmJobTypes: React.FC<FirmJobTypesProps> = ({ jobTypes }) => {
  if (!jobTypes || jobTypes.length === 0) {
    return null
  }

  return (
    <div>
      {jobTypes && jobTypes.length > 0 && (
        <div className="col-span-1 p-4">
          <h2 className="mb-2 text-lg font-semibold text-left text-night">
            Types de métiers
          </h2>
          <ul className="ml-2">
            {jobTypes?.map((jobType) => (
              <li
                className="lg:text-[16px] text-[14px] my-1"
                key={jobType?.value}
              >
                <div className="text-night">{jobType?.value}</div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}

export default FirmJobTypes

export const query = graphql`
  fragment FirmJobTypes on STRAPI_ACCOUNTING_FIRM {
    jobTypes {
      value
    }
  }
`
